<template>
	<div class="spaceHeader">
		<div class="title">
			<div class="fixation">
				<div class="left">
					尊敬的客户您好，欢迎来到北京大德国际拍卖有限公司！
				</div>
				<div class="right">
					<div class="item">
						<router-link to="/space">
							<i class="el-icon-user"></i>
							[ {{$store.state.userinfo.username}} ]
						</router-link>
					</div>
					<div class="item" @click="doLogout">
						<span>退出登录</span>
					</div>
					<div class="item">
						<i class="el-icon-phone-outline"></i>
						<span>
							{{phone}}
						</span>
					</div>
				</div>
			</div>
		</div>
		<div class="container">
			<div class="fixation">
				<div class="logo">
					<router-link to="/index">
						<img src="../../../assets/logo-white.png" alt="">
					</router-link>
				</div>
				<div class="navigate">
					<div :class="'navigate-item '+(menuIndex==index?'navigate-select':'')"
						v-for="(item,index) in navigate" :key="index">
						<router-link :to="{path:item.path}">
							{{item.name}}
						</router-link>
					</div>
				</div>
				<div class="search">
					<div class="search-box" v-if="menuIndex != 3">
						<div class="search-icon">
							<i class="el-icon-search"></i>
						</div>
						<div class="search-input">
							<input type="text" placeholder="请输入搜索关键词" v-model="keyword" @keydown.enter="keydown">
						</div>
						<div class="search-button" @click="keydown">
							搜索
						</div>
					</div>
				</div>
				<div class="avatar">
					<img src="../../../assets/avatar-none.png" alt="" v-if="!$store.state.userinfo.headImg">
					<img :src="$pub.imageUrl+$store.state.userinfo.headImg" alt="" v-else>
					{{$store.state.userinfo.username}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'spaceHeader',
		data() {
			return {
				phone: '',
				navigate: [{
						path: '/record',
						name: '我的拍卖'
					},
					{
						path: '/collection',
						name: '我的数字藏品'
					},
					{
						path: '/footprint',
						name: '我的足迹'
					},
					{
						path: '/setting',
						name: '账户设置'
					}
				],
				menuIndex: 0,
				keyword: ''
			};
		},
		watch: {
			$route(to, from) {
				let path = to.path
				let index = ['/record', '/collection', '/footprint', '/setting'].indexOf(path)
				this.menuIndex = index
				this.$pub.setStorage('menuIndex', index)
			}
		},
		methods: {
			...mapMutations(['logout']),
			doLogout() {
				this.$confirm('请问是否确认退出登录？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					distinguishCancelAndClose: true,
					closeOnClickModal: false
				}).then(() => {
					this.$message({
						type: 'success',
						message: '退出登录成功',
						duration: 1500,
						onClose: () => {
							this.logout()
						}
					});
				}).catch(() => {});
			},
			keydown() {
				this.$store.state.spaceKeyword = this.keyword
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.phone = this.$store.state.websiteConfig.contact[0]['value']
			this.userinfo = this.$store.state.userinfo
			if (this.$pub.getStorage('menuIndex')) {
				this.menuIndex = parseInt(this.$pub.getStorage('menuIndex'))
			}
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.spaceHeader {
		width: 100%;

		.title {
			width: 100%;
			height: 36px;
			background: @vue-bg-color-grey;

			.fixation {
				display: flex;
				justify-content: space-between;

				.left {
					height: 100%;
					display: flex;
					align-items: center;
					font-size: @vue-font-size-sm - 2;
				}

				.right {
					height: 100%;
					display: flex;
					align-items: center;

					.item {
						padding-left: @vue-spacing-row-base;
						display: flex;
						font-size: @vue-font-size-sm - 2;
						cursor: pointer;

						i {
							margin-right: @vue-spacing-row-sm / 2;
							margin-top: 3px;
						}

						span {
							color: @vue-text-color-red;
						}

						a {
							color: @vue-text-color-red;
						}
					}

					.item:first-child {
						border-right: 1px solid @vue-border-color;
						padding-right: @vue-spacing-row-base;
						cursor: pointer;
					}
				}
			}
		}

		.container {
			width: 100%;
			height: 110px;
			background: @vue-bg-color-red;

			.fixation {
				height: 100%;
				display: flex;
				justify-content: space-between;

				.logo,
				.navigate,
				.search,
				.avatar {
					height: 100%;
					display: flex;
					align-items: center;
				}

				.logo {
					width: 250px;
				}

				.navigate {
					width: 440px;
					display: flex;
					justify-content: space-between;

					.navigate-item {
						width: 125px;
						height: 100%;

						a {
							width: 100%;
							height: 100%;
							display: flex;
							justify-content: center;
							align-items: center;
							color: @vue-text-color-inverse;
						}
					}

					.navigate-select {
						background: linear-gradient(#eb3237, #f25458);
					}
				}

				.search {
					width: 300px;
					padding-left: @vue-spacing-row-base;
					box-sizing: border-box;
					display: flex;
					align-items: center;

					.search-box {
						width: 100%;
						height: 36px;
						background: @vue-bg-color-grey;
						border-radius: @vue-border-radius-base;
						display: flex;
						justify-content: space-between;
						overflow: hidden;

						.search-icon {
							width: 36px;
							height: 100%;
							display: flex;
							justify-content: center;
							align-items: center;
						}

						.search-input {
							width: calc(100% - 106px);
							height: 100%;

							input {
								width: 100%;
								height: 100%;
								border: none;
							}
							
							input::focus{
								border: none;
							}
						}

						.search-button {
							width: 70px;
							height: 100%;
							background: linear-gradient(#F3F3F3, #D9D9D9);
							display: flex;
							align-items: center;
							justify-content: center;
							font-size: @vue-font-size-sm - 2;
							color: @vue-text-color-grey;
							cursor: pointer;
						}
					}
				}

				.avatar {
					width: 210px;
					justify-content: flex-end;
					color: @vue-text-color-inverse;

					img {
						width: 60px;
						height: 60px;
						border-radius: @vue-border-radius-circle;
						margin-right: @vue-spacing-row-sm;
					}
				}
			}
		}
	}
</style>
